import './global.css';

import { getOrCreateI18n } from '@affine/i18n';
import { createRoot } from 'react-dom/client';

import { App } from './app';

// The standalone SPA must create + register the i18next instance (initReactI18next) before render —
// the mobile/web app shells do this in their bootstrap; here `useI18n()` (react-i18next useTranslation)
// otherwise has no instance and throws `t.exists is not a function`, blanking the authed screens.
getOrCreateI18n();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
createRoot(document.getElementById('app')!).render(<App />);
